/**
 * @file: PostponePicker.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The 已改期 reschedule card — shows the chosen target-service date and a spinner
 * to move it. Surfaces only when the outcome is 已改期.
 */

import { Typography } from '@euler/app/components/typography';
import { LD } from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import DateTimePicker from '@react-native-community/datetimepicker';
import format from 'date-fns/format';
import { CalendarClock } from 'lucide-react-native';
import { View } from 'react-native';
import { Card } from './common/Card';

export const PostponePicker = ({
  value,
  onChange,
}: {
  value: Date;
  onChange: (d: Date) => void;
}) => {
  const { rpx } = useResponsiveContext();
  return (
    <Card>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          paddingTop: rpx(12),
        }}
      >
        <CalendarClock size={rpx(18)} color={LD.brand} />
        <Typography.Text
          size={rpx(16)}
          color={LD.ink}
          bold
          style={{ marginLeft: rpx(8) }}
        >
          {format(value, 'yyyy-MM-dd')}
        </Typography.Text>
      </View>
      <View style={{ alignItems: 'center' }}>
        <DateTimePicker
          mode="date"
          display="spinner"
          value={value}
          onChange={(_e, d) => d && onChange(d)}
        />
      </View>
    </Card>
  );
};
